import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { TIME_FRAME } from '../../constants/filters.constants';
import { ChartData, ChartOptions } from 'chart.js';
import { ThemeService } from '../../../core/services/theme.service';
import { applyThemeColorsToChart } from '../../../core/services/test';
import { Subscription } from 'rxjs';

export interface TimeSeriesDataPoint {
  x: string | Date | number;
  y: number;
}

@Component({
  selector: 'app-interactive-time-chart',
  templateUrl: './interactive-time-chart.component.html',
  styleUrls: ['./interactive-time-chart.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractiveTimeChartComponent implements OnInit, OnDestroy {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  @Input() datasets: ChartData<'line'> | undefined;
  @Input() height: number = 400;
  @Input() loading: boolean = false;
  @Input() error: boolean = false;
  @Input() chartOptions: ChartOptions<'line'> = {};
  @Input() dateFormat: string = 'MMM dd, HH:mm';
  @Input() timePeriod: 'hour' | 'day' | 'week' | 'month' = 'day';
  @Input() selectedPeriod: string = TIME_FRAME.THREEMONTH;
  @Input() additionalPlugins: any[] = [];
  @Input() displayonReset: boolean = true;
  @Output() onZoom = new EventEmitter<{ min: Date; max: Date }>();
  @Output() onReset = new EventEmitter<void>();

  private themeSubscription?: Subscription;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeSubscription = this.themeService.darkMode$.subscribe(() => {
      // Apply theme colors when theme changes
      this.updateChartTheme();
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe();
  }

  private updateChartTheme(): void {
    if (this.chart?.chart) {
      applyThemeColorsToChart(this.chart.chart);
    }
  }

  public resetZoom(): void {
    if (this.chart?.chart) {
      this.chart.chart.resetZoom();
      this.onReset.emit();
      // Reapply theme colors after zoom reset
      this.updateChartTheme();
    }
  }

  public zoomToDateRange(startDate: Date, endDate: Date): void {
    if (this.chart?.chart) {
      this.chart.chart.zoomScale('x', {
        min: startDate.getTime(),
        max: endDate.getTime(),
      });
      // Reapply theme colors after zoom
      this.updateChartTheme();
    }
  }
}
